function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.5 0.824219C8.11116 0.824219 0.5 8.43538 0.5 17.8242C0.5 27.2131 8.11116 34.8242 17.5 34.8242C26.8888 34.8242 34.5 27.2131 34.5 17.8242C34.4898 8.43959 26.8846 0.834369 17.5 0.824219ZM17.5 31.9909C9.67597 31.9909 3.33333 25.6483 3.33333 17.8242C3.33333 10.0002 9.67597 3.65755 17.5 3.65755C25.324 3.65755 31.6667 10.0002 31.6667 17.8242C31.6581 25.6447 25.3205 31.9823 17.5 31.9909V31.9909Z",
  fill: "#F59E0B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.5 7.90625C16.7176 7.90625 16.0834 8.54051 16.0834 9.32292V20.6563C16.0834 21.4387 16.7176 22.0729 17.5 22.0729C18.2824 22.0729 18.9167 21.4387 18.9167 20.6563V9.32292C18.9167 8.54051 18.2824 7.90625 17.5 7.90625Z",
  fill: "#F59E0B"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 16.0834,
  y: 24.9062,
  width: 2.83333,
  height: 2.83334,
  rx: 1,
  fill: "#F59E0B"
});

function SvgExclamation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.f52c5fac.svg";
export { ForwardRef as ReactComponent };